export function getDarkLogoSrc(lightLogoSrc: string) {
  return lightLogoSrc.replace('logos/', 'logos/dark/').replace('.svg', '-dark.svg');
}
